import React, { useEffect, useRef, useState } from 'react';
import { Form, Select } from 'antd';
import { InfoCircleOutlined, OrderedListOutlined } from '@ant-design/icons';
import ReactDOM from 'react-dom';
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

export default (formPlugin, namespace) => {
    return {
        Renderer: (props) => {

            let containerRef = useRef(null)
            const [listField, setlistField] = useState(null)
            useEffect(() => {
                setlistField(props.pluginConfig.getListField(containerRef.current))
            }, [])

            if (props.remove) {
                formPlugin.onAddFormPlugin(props, props.nodeId, props.pluginConfig.id)
            }

            if ((props.isPreviewMode || props.readOnly) && !props.data.fieldKey) {
                return null
            }

            const { data } = props

            let rules = [{ required: data.required || false, message: t`Ce champ est obligatoire` }]

            let tooltip = null
            if (data.tooltip) {
                tooltip = {
                    title: data.tooltip,
                    icon: <InfoCircleOutlined />,
                }
            }

            let values = []
            if (Array.isArray(data.values)) {
                values = data.values
            }

            var prefix = "[SELECT]_"
            if (data.multiple) {
                prefix = "[SELECT_MULTI]_"
            }

            const listFieldProps = listField ? listField : null
            const finalName = prefix + data.fieldKey

            return (
                <div ref={(ref) => containerRef.current = ref}>
                    <Form.Item
                        {...listFieldProps}
                        label={`${data.label || t`Question`} :`}
                        name={listField ? [listField.name, finalName].flat() : finalName}
                        rules={rules}
                        tooltip={tooltip}
                    >
                        <Select
                            showSearch={false}
                            size={"middle"}
                            mode={data.multiple ? "multiple" : null}
                            placeholder={data.placeholder}
                        >
                            {values.map(i => (
                                <Select.Option value={i}>{i}</Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                </div>
            )
        },
        namespace: namespace,
        id: 'form-select' + namespace,
        title: t`Liste déroulante`,
        description: t`Élément de formulaire utilisable.`,
        icon: <OrderedListOutlined />,
        iconColor: "#F39C12",
        version: 1,
        getListField: (containerRef) => {
            const listField = ReactDOM.findDOMNode(containerRef)?.closest(".form-field")?.dataset.field
            if (listField) {
                return JSON.parse(listField)
            }
            return null
        },
        controls: {
            type: 'autoform',
            schema: {
                properties: {
                    required: {
                        type: 'boolean',
                        uniforms: {
                            label: t`Obligatoire`,
                        }
                    },
                    multiple: {
                        type: 'boolean',
                        uniforms: {
                            label: t`Choix multiple`,
                        }
                    },
                    fieldKey: {
                        type: 'string',
                        uniforms: {
                            required: true,
                            label: t`Identifiant`,
                            placeholder: t`Identifiant du champ`,
                        }
                    },
                    label: {
                        type: 'string',
                        uniforms: {
                            required: true,
                            label: t`Étiquette`,
                            placeholder: t`Libellé`,
                        }
                    },
                    placeholder: {
                        type: 'string',
                        uniforms: {
                            label: t`Sous-étiquette`,
                            placeholder: t`Sous-étiquette`,
                        }
                    },
                    tooltip: {
                        type: 'string',
                        uniforms: {
                            label: t`Message d'aide`,
                            placeholder: t`Message d'aide`,
                            multiline: true,
                            rows: 2,
                        }
                    },
                    defaultValue: {
                        type: "string",
                        uniforms: {
                            showIf: () => false,
                            label: t`Valeur par défaut`,
                        }
                    },
                    values: {
                        type: "array",
                        uniforms: {
                            label: t`Valeurs`,
                        },
                        items: {
                            type: "string",
                        },
                    },
                }
            },
        },
    }
}
